module.exports = __webpack_public_path__ + "img/ara_intestazione.cac36016.png";